/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DescriptionUpdate } from '../models/DescriptionUpdate';
import type { EditorDoc } from '../models/EditorDoc';
import type { JiraObject } from '../models/JiraObject';
import type { JiraObjectElevation } from '../models/JiraObjectElevation';
import type { JiraObjectElevationCreate } from '../models/JiraObjectElevationCreate';
import type { MetricAttachRequest } from '../models/MetricAttachRequest';
import type { MNPIAllowedAdd } from '../models/MNPIAllowedAdd';
import type { NotesUpdate } from '../models/NotesUpdate';
import type { Workstream } from '../models/Workstream';
import type { WorkstreamAccess } from '../models/WorkstreamAccess';
import type { WorkstreamAdminUpdatesResponse } from '../models/WorkstreamAdminUpdatesResponse';
import type { WorkstreamAuditLog } from '../models/WorkstreamAuditLog';
import type { WorkstreamAutoArchivePreview } from '../models/WorkstreamAutoArchivePreview';
import type { WorkstreamBasic } from '../models/WorkstreamBasic';
import type { WorkstreamBasicWithSummary } from '../models/WorkstreamBasicWithSummary';
import type { WorkstreamBreadcrumbPaths } from '../models/WorkstreamBreadcrumbPaths';
import type { WorkstreamContinueUpdatingResponse } from '../models/WorkstreamContinueUpdatingResponse';
import type { WorkstreamCount } from '../models/WorkstreamCount';
import type { WorkstreamCreate } from '../models/WorkstreamCreate';
import type { WorkstreamDraftPolicy } from '../models/WorkstreamDraftPolicy';
import type { WorkstreamDraftPolicyUpdate } from '../models/WorkstreamDraftPolicyUpdate';
import type { WorkstreamEdit } from '../models/WorkstreamEdit';
import type { WorkstreamEditorDocs } from '../models/WorkstreamEditorDocs';
import type { WorkstreamMetric } from '../models/WorkstreamMetric';
import type { WorkstreamMetricBatchPatch } from '../models/WorkstreamMetricBatchPatch';
import type { WorkstreamMetricCreate } from '../models/WorkstreamMetricCreate';
import type { WorkstreamMetricEdit } from '../models/WorkstreamMetricEdit';
import type { WorkstreamOrphansResponse } from '../models/WorkstreamOrphansResponse';
import type { WorkstreamUpdate } from '../models/WorkstreamUpdate';
import type { WorkstreamUpdateCreate } from '../models/WorkstreamUpdateCreate';
import type { WorkstreamUpdateEdit } from '../models/WorkstreamUpdateEdit';
import type { WorkstreamUpdateSummaryEdit } from '../models/WorkstreamUpdateSummaryEdit';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkstreamService {

    /**
     * Check Mnpi Access
     * Check if the current user has access to MNPI metrics.
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static checkMnpiAccessApiV1WorkstreamMnpiCheckGet(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/mnpi/check',
        });
    }

    /**
     * List Mnpi Allowed
     * List user_ids that have MNPI Admin access.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static listMnpiAllowedApiV1WorkstreamMnpiGet(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/mnpi',
        });
    }

    /**
     * Add Mnpi Allowed
     * Add a user to the MNPI Admin allow list. User admin only.
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static addMnpiAllowedApiV1WorkstreamMnpiPost(
        requestBody: MNPIAllowedAdd,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/mnpi',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Mnpi Allowed
     * List user_ids that have MNPI Admin access.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static listMnpiAllowedApiV1WorkstreamMnpiAllowedEmployeesGet(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/mnpi/allowed-employees',
        });
    }

    /**
     * Add Mnpi Allowed
     * Add a user to the MNPI Admin allow list. User admin only.
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static addMnpiAllowedApiV1WorkstreamMnpiAllowedEmployeesPost(
        requestBody: MNPIAllowedAdd,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/mnpi/allowed-employees',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Remove Mnpi Allowed
     * Remove a user from the MNPI Admin allow list. User admin only.
     * @param userId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static removeMnpiAllowedApiV1WorkstreamMnpiUserIdDelete(
        userId: string,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/workstream/mnpi/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Remove Mnpi Allowed
     * Remove a user from the MNPI Admin allow list. User admin only.
     * @param userId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static removeMnpiAllowedApiV1WorkstreamMnpiAllowedEmployeesUserIdDelete(
        userId: string,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/workstream/mnpi/allowed-employees/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Workstream Draft Policy
     * @returns WorkstreamDraftPolicy Successful Response
     * @throws ApiError
     */
    public static getWorkstreamDraftPolicyApiV1WorkstreamPolicyGet(): CancelablePromise<WorkstreamDraftPolicy> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/policy',
        });
    }

    /**
     * Put Workstream Draft Policy
     * @param requestBody
     * @returns WorkstreamDraftPolicy Successful Response
     * @throws ApiError
     */
    public static putWorkstreamDraftPolicyApiV1WorkstreamPolicyPut(
        requestBody: WorkstreamDraftPolicyUpdate,
    ): CancelablePromise<WorkstreamDraftPolicy> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/workstream/policy',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Auto Archive Preview
     * @returns WorkstreamAutoArchivePreview Successful Response
     * @throws ApiError
     */
    public static getAutoArchivePreviewApiV1WorkstreamAdminAutoArchiveGet(): CancelablePromise<WorkstreamAutoArchivePreview> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/admin/auto-archive',
        });
    }

    /**
     * Get Admin Workstream Updates
     * @returns WorkstreamAdminUpdatesResponse Successful Response
     * @throws ApiError
     */
    public static getAdminWorkstreamUpdatesApiV1WorkstreamAdminUpdatesGet(): CancelablePromise<WorkstreamAdminUpdatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/admin/updates',
        });
    }

    /**
     * Get Admin Orphaned Workstreams
     * @returns WorkstreamOrphansResponse Successful Response
     * @throws ApiError
     */
    public static getAdminOrphanedWorkstreamsApiV1WorkstreamAdminOrphanedGet(): CancelablePromise<WorkstreamOrphansResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/admin/orphaned',
        });
    }

    /**
     * Status
     * @param employeeId
     * @param requestBody
     * @returns number Successful Response
     * @throws ApiError
     */
    public static statusApiV1WorkstreamUpdatePost(
        employeeId: string,
        requestBody: WorkstreamUpdateCreate,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/update',
            query: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Edit Update
     * @param requestBody
     * @returns number Successful Response
     * @throws ApiError
     */
    public static editUpdateApiV1WorkstreamUpdatePut(
        requestBody: WorkstreamUpdateEdit,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/workstream/update',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Edit Update Summary
     * Set an update's summary by hand, or reset it to AI with an empty one.
     *
     * Always audit-logged (no skip_audit_log): a person's edit is never
     * regenerated, so the log is the record of who wrote it.
     * @param id
     * @param requestBody
     * @returns WorkstreamUpdate Successful Response
     * @throws ApiError
     */
    public static editUpdateSummaryApiV1WorkstreamUpdateIdSummaryPut(
        id: number,
        requestBody: WorkstreamUpdateSummaryEdit,
    ): CancelablePromise<WorkstreamUpdate> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/workstream/update/{id}/summary',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Update
     * @param id
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static deleteUpdateApiV1WorkstreamUpdateIdDelete(
        id: number,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/workstream/update/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create
     * @param requestBody
     * @param archive
     * @returns number Successful Response
     * @throws ApiError
     */
    public static createApiV1WorkstreamPost(
        requestBody: WorkstreamCreate,
        archive: boolean = false,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream',
            query: {
                'archive': archive,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Edit
     * @param employeeId
     * @param requestBody
     * @param reason
     * @returns number Successful Response
     * @throws ApiError
     */
    public static editApiV1WorkstreamPut(
        employeeId: string,
        requestBody: WorkstreamEdit,
        reason?: (string | null),
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/workstream',
            query: {
                'reason': reason,
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Notes
     * @param id
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static notesApiV1WorkstreamIdNotesPut(
        id: number,
        requestBody: NotesUpdate,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/workstream/{id}/notes',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Description
     * @param id
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static descriptionApiV1WorkstreamIdDescriptionPut(
        id: number,
        requestBody: DescriptionUpdate,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/workstream/{id}/description',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete
     * @param id
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static deleteApiV1WorkstreamIdArchivePost(
        id: number,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/{id}/archive',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Undelete
     * @param id
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static undeleteApiV1WorkstreamIdUnarchivePost(
        id: number,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/{id}/unarchive',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Trackers
     * @returns WorkstreamBasic Successful Response
     * @throws ApiError
     */
    public static getTrackersApiV1WorkstreamTrackersGet(): CancelablePromise<Array<WorkstreamBasic>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/trackers',
        });
    }

    /**
     * Search Workstreams
     * @param query
     * @param limit
     * @returns WorkstreamBasic Successful Response
     * @throws ApiError
     */
    public static searchWorkstreamsApiV1WorkstreamSearchGet(
        query: string,
        limit: number = 10,
    ): CancelablePromise<Array<WorkstreamBasic>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/search',
            query: {
                'query': query,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Continue Updating Candidates
     * @param excludeWorkstreamId
     * @param limit
     * @param cursor
     * @returns WorkstreamContinueUpdatingResponse Successful Response
     * @throws ApiError
     */
    public static getContinueUpdatingCandidatesApiV1WorkstreamContinueUpdatingGet(
        excludeWorkstreamId?: (number | null),
        limit: number = 5,
        cursor?: (string | null),
    ): CancelablePromise<WorkstreamContinueUpdatingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/continue-updating',
            query: {
                'exclude_workstream_id': excludeWorkstreamId,
                'limit': limit,
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Seed workstreams from prod
     * Start workstream seed from production API in the background. Returns immediately.
     * Only available in non-production (e.g. stage).
     * @returns string Successful Response
     * @throws ApiError
     */
    public static seedWorkstreamsApiV1WorkstreamSeedGet(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/seed',
        });
    }

    /**
     * Get Company
     * @param timeframe
     * @returns WorkstreamBasicWithSummary Successful Response
     * @throws ApiError
     */
    public static getCompanyApiV1WorkstreamCompanyGet(
        timeframe?: (string | null),
    ): CancelablePromise<Array<WorkstreamBasicWithSummary>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/company',
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Editordocs
     * @param id
     * @returns WorkstreamEditorDocs Successful Response
     * @throws ApiError
     */
    public static getEditordocsApiV1WorkstreamEditordocsGet(
        id: number,
    ): CancelablePromise<Array<WorkstreamEditorDocs>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/editordocs',
            query: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Logs
     * @param id
     * @returns WorkstreamAuditLog Successful Response
     * @throws ApiError
     */
    public static getLogsApiV1WorkstreamIdLogsGet(
        id: number,
    ): CancelablePromise<Array<WorkstreamAuditLog>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/logs',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Metric Logs
     * @param startDate
     * @param endDate
     * @returns WorkstreamAuditLog Successful Response
     * @throws ApiError
     */
    public static getMetricLogsApiV1WorkstreamLogsMetricsGet(
        startDate: string,
        endDate: string,
    ): CancelablePromise<Array<WorkstreamAuditLog>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/logs/metrics',
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Updates
     * @param id
     * @returns WorkstreamUpdate Successful Response
     * @throws ApiError
     */
    public static getUpdatesApiV1WorkstreamIdUpdatesGet(
        id: number,
    ): CancelablePromise<Array<WorkstreamUpdate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/updates',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Linkable Metrics
     * @param id
     * @param allowAllMetricTypes
     * @returns WorkstreamMetric Successful Response
     * @throws ApiError
     */
    public static getLinkableMetricsApiV1WorkstreamIdMetricsLinkableGet(
        id: number,
        allowAllMetricTypes: boolean = false,
    ): CancelablePromise<Array<WorkstreamMetric>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/metrics/linkable',
            path: {
                'id': id,
            },
            query: {
                'allow_all_metric_types': allowAllMetricTypes,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Elevatable Jira Objects
     * @param id
     * @returns JiraObject Successful Response
     * @throws ApiError
     */
    public static getElevatableJiraObjectsApiV1WorkstreamIdJiraElevatableGet(
        id: number,
    ): CancelablePromise<Array<JiraObject>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/jira/elevatable',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Elevate Jira Object
     * @param id
     * @param requestBody
     * @returns JiraObjectElevation Successful Response
     * @throws ApiError
     */
    public static elevateJiraObjectApiV1WorkstreamIdJiraElevatePost(
        id: number,
        requestBody: JiraObjectElevationCreate,
    ): CancelablePromise<JiraObjectElevation> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/{id}/jira/elevate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Detach Jira Object Elevation
     * @param id
     * @param jiraObjectId
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static detachJiraObjectElevationApiV1WorkstreamIdJiraJiraObjectIdElevationDelete(
        id: number,
        jiraObjectId: number,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/workstream/{id}/jira/{jira_object_id}/elevation',
            path: {
                'id': id,
                'jira_object_id': jiraObjectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Metric
     * @param id
     * @param requestBody
     * @param reason
     * @param skipAuditLog
     * @returns WorkstreamMetric Successful Response
     * @throws ApiError
     */
    public static createMetricApiV1WorkstreamIdMetricsPost(
        id: number,
        requestBody: WorkstreamMetricCreate,
        reason?: (string | null),
        skipAuditLog: boolean = false,
    ): CancelablePromise<WorkstreamMetric> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/{id}/metrics',
            path: {
                'id': id,
            },
            query: {
                'reason': reason,
                'skip_audit_log': skipAuditLog,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Attach Metric
     * @param id
     * @param requestBody
     * @param reason
     * @param skipAuditLog
     * @returns WorkstreamMetric Successful Response
     * @throws ApiError
     */
    public static attachMetricApiV1WorkstreamIdMetricsAttachPost(
        id: number,
        requestBody: MetricAttachRequest,
        reason?: (string | null),
        skipAuditLog: boolean = false,
    ): CancelablePromise<WorkstreamMetric> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/{id}/metrics/attach',
            path: {
                'id': id,
            },
            query: {
                'reason': reason,
                'skip_audit_log': skipAuditLog,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Metric
     * @param id
     * @param metricId
     * @param requestBody
     * @param reason
     * @param skipAuditLog
     * @returns WorkstreamMetric Successful Response
     * @throws ApiError
     */
    public static updateMetricApiV1WorkstreamIdMetricsMetricIdPut(
        id: number,
        metricId: number,
        requestBody: WorkstreamMetricEdit,
        reason?: (string | null),
        skipAuditLog: boolean = false,
    ): CancelablePromise<WorkstreamMetric> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/workstream/{id}/metrics/{metric_id}',
            path: {
                'id': id,
                'metric_id': metricId,
            },
            query: {
                'reason': reason,
                'skip_audit_log': skipAuditLog,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Metric
     * @param id
     * @param metricId
     * @param reason
     * @param skipAuditLog
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static deleteMetricApiV1WorkstreamIdMetricsMetricIdDelete(
        id: number,
        metricId: number,
        reason?: (string | null),
        skipAuditLog: boolean = false,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/workstream/{id}/metrics/{metric_id}',
            path: {
                'id': id,
                'metric_id': metricId,
            },
            query: {
                'reason': reason,
                'skip_audit_log': skipAuditLog,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Batch Patch Metrics
     * Batch-update current values and/or status for metrics on a workstream.
     * @param id
     * @param requestBody
     * @returns WorkstreamMetric Successful Response
     * @throws ApiError
     */
    public static batchPatchMetricsApiV1WorkstreamIdMetricsBatchPatch(
        id: number,
        requestBody: WorkstreamMetricBatchPatch,
    ): CancelablePromise<Array<WorkstreamMetric>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/workstream/{id}/metrics/batch',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Parent Workstream
     * @param id
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getParentWorkstreamApiV1WorkstreamIdParentGet(
        id: number,
    ): CancelablePromise<(Workstream | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/parent',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Parent Workstreams
     * @param id
     * @returns Workstream Successful Response
     * @throws ApiError
     */
    public static getParentWorkstreamsApiV1WorkstreamIdParentsGet(
        id: number,
    ): CancelablePromise<Array<Workstream>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/parents',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Workstream Breadcrumb Paths
     * @param id
     * @returns WorkstreamBreadcrumbPaths Successful Response
     * @throws ApiError
     */
    public static getWorkstreamBreadcrumbPathsApiV1WorkstreamIdBreadcrumbPathsGet(
        id: number,
    ): CancelablePromise<WorkstreamBreadcrumbPaths> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/breadcrumb-paths',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get
     * @param id
     * @param reports
     * @param delegates
     * @returns WorkstreamAccess Successful Response
     * @throws ApiError
     */
    public static getApiV1WorkstreamIdGet(
        id: (number | string),
        reports?: (boolean | null),
        delegates?: (boolean | null),
    ): CancelablePromise<WorkstreamAccess> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}',
            path: {
                'id': id,
            },
            query: {
                'reports': reports,
                'delegates': delegates,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Count
     * @param id
     * @param reports
     * @param delegates
     * @returns WorkstreamCount Successful Response
     * @throws ApiError
     */
    public static getCountApiV1WorkstreamIdCountGet(
        id: (number | string),
        reports?: (boolean | null),
        delegates?: (boolean | null),
    ): CancelablePromise<WorkstreamCount> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/count',
            path: {
                'id': id,
            },
            query: {
                'reports': reports,
                'delegates': delegates,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Request Permission
     * @param id
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static requestPermissionApiV1WorkstreamAccessPost(
        id: number,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/access',
            query: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Switchboard
     * @param workstreamId
     * @returns EditorDoc Successful Response
     * @throws ApiError
     */
    public static createSwitchboardApiV1WorkstreamSwitchboardPut(
        workstreamId: number,
    ): CancelablePromise<EditorDoc> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/workstream/switchboard',
            query: {
                'workstream_id': workstreamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Grant Permission
     * @param id
     * @param allow
     * @param requesterLdap
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static grantPermissionApiV1WorkstreamGrantPost(
        id: number,
        allow: boolean,
        requesterLdap: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/grant',
            query: {
                'id': id,
                'allow': allow,
                'requester_ldap': requesterLdap,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Jira Objects
     * Fetch roadmap initiatives for a workstream from the database. With
     * `refresh`, also refresh them from Jira in the background; open pages
     * refetch when they change.
     * @param id
     * @param refresh Also refresh them from Jira in the background (a page reading them closely).
     * @returns JiraObject Successful Response
     * @throws ApiError
     */
    public static getJiraObjectsApiV1WorkstreamIdJiraGet(
        id: number,
        refresh: boolean = false,
    ): CancelablePromise<Array<JiraObject>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/jira',
            path: {
                'id': id,
            },
            query: {
                'refresh': refresh,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
